import { TypeComponentTextInput } from '@lib/types/component-text-input'
import React, { useContext } from 'react'

// NOTE: avoid value type here that changes after mount. use what react-hook-form offers instead to properly handle validation/state.
export type FormOverrideFieldType = Pick<TypeComponentTextInput['fields'], 'isHidden' | 'name'>

interface FormOverrideContextType {
  overrideFields: FormOverrideFieldType[]
}

export const FormOverrideContext = React.createContext<FormOverrideContextType>({
  overrideFields: [],
})

export const useFormOverrideContext = () => useContext(FormOverrideContext)
